// extracted by mini-css-extract-plugin
export default {"loader":"SmallLoader_loader__kvPMY","rotation":"SmallLoader_rotation__hJog0"};